module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner_stores/banner_stores_funabashi-29a808324c1f40983cabb55978dcb953.jpg";